import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CrudService } from 'src/app/core/services/crud.service';
import {
  fetchAris360List,
  fetchAris360ListSuccess,
  fetchAris360ListFailure,
  fetchAris360Detail,
  fetchAris360DetailSuccess,
  fetchAris360DetailFailure,
  assignAgent,
  assignAgentSuccess,
  assignAgentFailure,
} from './aris360.action';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class Aris360Effects {
  constructor(
    private actions$: Actions,
    private CrudService: CrudService,
    private snackBar: MatSnackBar
  ) {}

  fetchData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAris360List),
      mergeMap((action) =>
        this.CrudService.postData(
          'Admin/Listing/GetListings',
          action.payload
        ).pipe(
          map((result) => fetchAris360ListSuccess({ response: result })),

          catchError((error) => of(fetchAris360ListFailure({ error })))
        )
      )
    )
  );

  fetchDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAris360Detail),
      mergeMap((action) =>
        this.CrudService.getData('Admin/Listing/' + action.payload.id).pipe(
          map((result) => fetchAris360DetailSuccess({ response: result })),

          catchError((error) => of(fetchAris360DetailFailure({ error })))
        )
      )
    )
  );

  assignAgent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(assignAgent),
      mergeMap((action) =>
        this.CrudService.patchData(`Admin/Listing/AssignListingToAgent?listingId=${action.payload.id}&agentUserId=${action.payload.agentId}`,{}).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.open('Agent assign successfully', '', {
                duration: 3000,
                panelClass: 'success',
              });
            } else {
              this.snackBar.open(result.message, '', {
                duration: 3000,
                panelClass: 'danger',
              });
            }
          }),
          mergeMap((res) => [
            assignAgentSuccess({ response: res.result }),
            fetchAris360List({
              payload: { pageNumber: 1, pageSize: 10, sortColumn: 'id', sortOrder: 'z', search: '' }
            })
          ]),
          catchError((error) => {
            return of(assignAgentFailure({ error }));
          })
        )
      )
    )
  );
}
